import { handleSkillCall as executeSkillCall } from '../../skills/handle-skill-call.js';
import type { BridgeMessageHandler } from '../message-router.js';

export const handleSkillCallMessage: BridgeMessageHandler<'skill_call'> = (msg, { getWs, log }) => {
  const skillId = typeof msg.skillId === 'string' ? msg.skillId : '';
  const operationId = typeof msg.operationId === 'string' ? msg.operationId : '';
  if (!skillId || !operationId) return;
  const socket = getWs();
  if (!socket) return;
  executeSkillCall(
    { id: msg.id, skillId, operationId, params: msg.params },
    socket,
    log,
  );
};
